import React from 'react';
import SecaoLocalExposicao from '@alweb-merkator/shared/pages/PaginaInicial/SecaoLocalExposicao';
import { useTranslation } from 'react-i18next';

function SecaoSerraPark(props) {
  const { t } = useTranslation();

  const googleMapsUrl =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1264.658699180919!2d-51.135940522047925!3d-29.702351860538577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9519425659e7aec9%3A0x5f7d7083ed4a6a9b!2sAv.%20Na%C3%A7%C3%B5es%20Unidas%2C%203827%20-%20Rio%20Branco%2C%20Novo%20Hamburgo%20-%20RS%2C%20Brasil!5e0!3m2!1spt-BR!2spt!4v1755075445268!5m2!1spt-BR!2spt';

  return (
    <SecaoLocalExposicao
      googleMapsUrl={googleMapsUrl}
      slugKey={t('slugs.fenac')}
      {...props}
    />
  );
}

export default SecaoSerraPark;
